// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pi7C","newExpiryDate":"styles_newExpiryDate__2J-MA","footer":"styles_footer__1cV_6"};